import { PqrFilterWeb } from '../../../../../shared/types/modules/pqr';
import * as Yup from 'yup';

export const initialValues: PqrFilterWeb = {
    consecutiveFormat: '',
    document: '',
    typeDocument: '',
};

export const validationSchema = Yup.object({
    consecutiveFormat: Yup.string().required('El número de PQR es obligatorio'),
    document: Yup.string().required('El número de documento es obligatorio'),
    country: Yup.string().required('El país es obligatorio'),
    typeDocument: Yup.string().required('La ubicación PQR es obligatoria'),
});
